import React, { useContext } from "react";
import type { ColorToken } from "../../../theme/styled";
import type { IconProps } from "../../icons/new-icons";
import { ButtonContext } from "../context";

/**
 * Using Button.Icon will remove minWidth from button when only child.
 */
export const Icon = ({
  iconComponent: Icon,
  color,
}: {
  iconComponent: (props: IconProps) => React.JSX.Element;
  color?: ColorToken;
}): React.JSX.Element => {
  const context = useContext(ButtonContext);

  return <Icon colorToken={color} size={context?.size === "small" ? 16 : 24} />;
};
